import { Component, input, booleanAttribute } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-splash-screen',
  standalone: true,
  imports: [CommonModule],
  template: `
    @if (visible()) {
      <div
        class="fixed inset-0 z-9999 flex flex-col items-center justify-center bg-white transition-opacity duration-500"
        [class.opacity-0]="fadeOut()"
        [class.pointer-events-none]="fadeOut()">

        <!-- Logo block -->
        <div class="flex items-center gap-4 mb-10">
          <div class=" rounded-xl">
            <img src="logo.svg" class="h-32" alt="App-Solid logo" />
          </div>
        </div>

        <!-- Spinner -->
        <div class="splash-spinner"></div>
      </div>
    }
  `,
  styles: `
    .splash-spinner {
      width: 40px;
      height: 40px;
      border: 3.5px solid #E5E7EB;
      border-top-color: #00B5CB;
      border-radius: 50%;
      animation: spin 0.8s linear infinite;
    }

    @keyframes spin {
      to { transform: rotate(360deg); }
    }
  `,
})
export class SplashScreen {
  /** Whether the splash screen is visible. */
  visible = input(true, { transform: booleanAttribute });

  /** Triggers the fade-out animation before removal. */
  fadeOut = input(false, { transform: booleanAttribute });
}
